<template>
  <div class="home">
    <iframe style="width: 100%; height: 100%" @load="load" :src="src" ref="iframeDom" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      key: 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0',
      glbComponent: null,
      sweepList: null,
      currentdata: '',
      sweep_index: null,
      audioUrl: '',
      isPlaying: false,
      is_true: false
    }
  },
  computed: {
    src() {
      return this.$store.state.settings.iframeUrl + '&vvvvv=' + new Date().getTime()
    }
  },

  methods: {
    load(e) {
      var MPSDK = window.MP_SDK || e.target.contentWindow.MP_SDK
      try {
        MPSDK.connect(e.target, this.key || 'e164e4ee-a42f-4c9b-937e-a4d8a315f6c0', '3.2')
          .then(async sdk => {
            this.$emit('ready', sdk)
            this.currentSweep(sdk)
            window.sdk = sdk
          })
          .catch(e => {
            console.error(e)
          })
      } catch (e) {
        console.error(e)
      }
    },

    isHashValuePresent(arr, targetHash) {
      // 遍历每个子数组
      for (const subArray of arr) {
        // 检查子数组是否包含目标哈希值
        if (subArray.includes(targetHash)) {
          // 如果找到目标哈希值，返回 true
          return true
        }
      }
      // 在所有子数组中都没有找到目标哈希值，返回 false
      return false
    },

    currentSweep(mpSdk) {
      const that = this

      mpSdk.Sweep.current.subscribe(function(currentSweep) {
        const arr = [
          // 前言
          ['0c3b7cb1622f4d9a8109f2d8834195d4', 'efd91fbacc914fc397e616f1f617cfd4'],
          // 第一单元
          ['87eae31fb7394817bcf9b569265cbaaf', 'b60645b237874167aa73bdbef27e0015', '4685d663b72e45359b760a7b2f0669ab', '0c22653205774048991b3032d92a3447'],
          // 第一单元(明清丝路上的中国白)
          ['1970376236854fa281a29cae550b8ef6'],
          // 黄金时代
          ['7428d1ab9e634b3991f8321d8122b6a0'],
          // 5 窑业初兴
          ['01a2436ee1b24d56a3a823c3cdfa2264', 'd157c373bbd44262a95f391095dbf686'],
          // 6 第一单元(随着市场需求的变化)
          ['7be4e71fc3e94e81b26d16e659311f28'],
          // 7 在南中国海域，
          ['65d64be5f0d94e0988e2a29435520363', 'a50cdfb01e5d4342adfa03adf8c42d8a', '7cc04ec097c947399bae286c6dd94305'],
          // 8 第二单元(瓷中明珠天下共宝)
          ['81aebccbe6384eeabb7871e8120ef1ce', '4f05f159b9f24ae59b97d9ac7344911e', '1d23a6d38d574a07983fdc722898cbdf', 'be08fd4f700f4c54bbd2a958af97a297'],
          // 9 第二单元(工巧若神)
          ['b9e87f59aac34c509ed002cda32e2af2', '90fd0291802c400bb51aefbbb14e1d50'],
          // 10 第二单元(名扬中外)
          ['bb0a2ab875604f7189e73d9e26802e91', 'ba84f6de8121459a9021191ce6daff61'],
          // 11 第三单元(千秋瓷业)
          ['42a9edd24c8a435788ed1a8289313200'],
          // 12 第三单元(薪火相传德化瓷传统烧制技艺)
          ['0fd8cc97abb640d7ba085b7723a831ae']
        ]

        if (currentSweep.sid) {
          const isPresent = that.isHashValuePresent(arr, currentSweep.sid)
          if (isPresent) {
            console.log('存在')
            arr.forEach((item, index) => {
              if (item.includes(currentSweep.sid)) {
                that.$store.commit('settings/SWEEP_INDEX', index)
              }
            })
          } else {
            console.log('空')
            that.$store.commit('settings/SWEEP_INDEX', 12)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
iframe {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.home {
  position: relative;
  width: 100vw;
  height: 100vh;
}

.help {
  width: 800px;
  height: 60px;
  z-index: 999999;
  position: absolute;
  right: 0;
  top: 0;
}
</style>
